export default `# Second Screen

The second screen is an external display (projector, TV, or ultra-wide monitor) that shows session content to the room. Configure what's displayed and how it's laid out.

---

## Setting Up

1. Click **Open Second Screen** to launch the display in a new browser window
2. Drag the window to your external monitor
3. Press **F11** for fullscreen

The connection status indicator shows whether the second screen window is currently open.

---

## Preset Layouts

Select from pre-built layouts that arrange widgets on screen. Each preset shows:
- A thumbnail preview of the layout
- The preset name (e.g. "4-Column Grid")
- How many widgets it includes

Click any preset to apply it immediately.

---

## Custom Layout

Click **Customize Layout** to open an advanced editor where you can drag and arrange individual widgets to create your own layout.

---

## Tips

- **Use the floating toolbar** on the second screen window to quickly switch presets or toggle dark/light mode during the session
- **Spotlight contributions** from the Contributions panel to display key ideas on the second screen
- **Dark mode** is often better in dimly lit rooms — toggle from the second screen's toolbar`;
